export { useStandbyCustomerEntriesQuery } from './useStandbyCustomerEntriesQuery';
export type { UseStandbyCustomerEntriesQueryOptions } from './types';
